 
  
  export const COIN_PACKS = [
    { id: 1, coins: 500, gems: 50 },
    { id: 2, coins: 1500, gems: 120 },
    { id: 3, coins: 5000, gems: 350 },
  ];
  
  export const BUNDLES = [
    {
      id: 1,
      name: "Starter Bundle",
      coins: 1000,
      priceCoins: 500,
    },
    {
      id: 2,
      name: "Pro Bundle",
      coins: 5000,
      priceCoins: 2500,
    },
  ];
  
  export const CURSORS = [
    { id: 1, name: "Classic Arrow", gems: 0 },
    { id: 2, name: "Neon Arrow", gems: 80 },
    { id: 3, name: "Fire Arrow", gems: 150 },
  ];
  